// 商品管理
import $ from '../base'

export default {

  // 分类 - 列表
  categoryList: $.post('commodity/queryCommLabels'),

  // 分类 - 新增
  categoryCreate: $.post('commodity/addCommLabel'),

  // 分类 - 编辑
  categoryUpdate: $.post('commodity/editCommLabel'),

  // 分类 - 删除
  categoryDelete: $.post('commodity/delCommLabel'),

  // 商品 - 列表
  commodityList: $.post('commodity/queryCommodities'),

  // 商品 - 新增/编辑
  commodityCreateUpdate: $.post('commodity/addOrEditCommodity'),

  // 商品 - 上下架
  commodityUpDown: $.post('commodity/downOrUpCommodity'),

  // 商品 - 详情
  commodityDetail: $.post('commodity/queryCommodityDetail')

}
